import createIcon from '../../createIcon';

/**
 * @component @name GraphicEq
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAxOEg5VjZIN1YxOFpNMTEgMjJIMTNWMkgxMVYyMlpNMyAxNEg1VjEwSDNWMTRaTTE1IDE4SDE3VjZIMTVWMThaTTE5IDEwVjE0SDIxVjEwSDE5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GraphicEq = createIcon('GraphicEq', [
  [
    'path',
    {
      d: 'M7 18H9V6H7V18ZM11 22H13V2H11V22ZM3 14H5V10H3V14ZM15 18H17V6H15V18ZM19 10V14H21V10H19Z',
      key: '466ib2',
    },
  ],
]);

export default GraphicEq;
